import { Suspense, useEffect } from "react";
// import { useCurrentuser } from "../../hooks/useUser";
import { Outlet, Navigate, useNavigate, useLocation } from "react-router-dom";
// import Layout from "../../components/layout";
// import SplashLoader from "../../components/ui/loader";
import Layout from "../Layout/ProtectedLayout";
import SplashLoader from "../ui/SplashLoader";
import { useAuth, useInactivityTimer } from "../../Lib/Hooks";

const ProtectedRoutes = () => {
  const { authenticated, isPasswordReset } = useAuth();

  // Enable inactivity timer for authenticated users
  useInactivityTimer();

  return authenticated ? (
    <>
      {/* <Suspense fallback={<SplashLoader />}> */}
      {/* <Layout> */}
      <Outlet />
      {/* </Layout> */}
      {/* </Suspense> */}
    </>
  ) : isPasswordReset ? (
    <Navigate to="/reset-password" />
  ) : (
    <Navigate to="/" />
  );
};

export default ProtectedRoutes;
